import { FileText, AudioLines, CircleStop } from 'lucide-react';
import type { TaskStatus } from '@/lib/api';

interface ControlPanelProps {
  producerStatus: TaskStatus;
  audioStatus: TaskStatus;
  onStartProducer: () => void;
  onStartAudio: () => void;
  onStopAll: () => void;
  isLoading: boolean;
}

export function ControlPanel({
  producerStatus,
  audioStatus,
  onStartProducer,
  onStartAudio,
  onStopAll,
  isLoading
}: ControlPanelProps) {
  const isAnyRunning = producerStatus.status === 'running' || audioStatus.status === 'running';

  return (
    <div className="card">
      <h3 className="font-semibold text-gray-200 mb-4">控制面板</h3>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        <button
          onClick={onStartProducer}
          disabled={isLoading || producerStatus.status === 'running'}
          className="btn btn-primary flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <FileText className="w-5 h-5" />
          <span>生成脚本</span>
        </button>

        <button
          onClick={onStartAudio}
          disabled={isLoading || audioStatus.status === 'running'}
          className="btn btn-primary flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <AudioLines className="w-5 h-5" />
          <span>生成音频</span>
        </button>

        <button
          onClick={onStopAll}
          disabled={!isAnyRunning}
          className="btn btn-danger flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <CircleStop className="w-5 h-5" />
          <span>停止任务</span>
        </button>
      </div>

      {isAnyRunning && (
        <p className="mt-4 text-sm text-gray-500 text-center">
          任务运行中，请勿关闭页面
        </p>
      )}
    </div>
  );
}
